export default __webpack_public_path__ + "static/media/checklist3.48c7e01b.png";